import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaPremium() {
  return (
    <section className="relative bg-ink text-bone overflow-hidden">
      <div className="absolute inset-0 opacity-40">
        <img
          src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=80&w=2400"
          alt="" className="w-full h-full object-cover kb"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/50" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
        <div className="text-eyebrow text-amber mb-8 rv">— 006 • Begin</div>
        <h2 className="font-display-tight text-6xl md:text-8xl lg:text-[10rem] leading-[0.9] text-bone max-w-5xl mb-12 text-balance rv">
          Let&apos;s build<br />something <span className="italic font-display text-amber">remarkable.</span>
        </h2>

        <div className="grid lg:grid-cols-12 gap-10 items-end rv">
          <div className="lg:col-span-7 text-bone/75 text-lg leading-relaxed max-w-2xl">
            Every project starts with a single conversation. Book a complimentary site visit with a senior partner — we&apos;ll listen, sketch, and return a fully costed proposal within two weeks.
          </div>
          <div className="lg:col-span-5 flex flex-col gap-3">
            <Link to="/contact" className="group btn-magnetic flex items-center justify-between bg-amber text-ink px-8 py-6 hover:bg-bone transition-colors">
              <span className="text-[12px] tracking-[0.25em] uppercase font-bold">Book a Consultation</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </Link>
            <Link to="/services" className="group btn-magnetic flex items-center justify-between border border-bone/40 px-8 py-6 hover:bg-bone/10 transition-colors">
              <span className="text-[12px] tracking-[0.25em] uppercase font-semibold">Browse our Services</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
